import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

// Password input with a show/hide toggle. Toggling only flips the input `type`, so
// browser/password-manager autofill keeps working. The toggle is a real 44px tap target.
export const PasswordField = ({
  value,
  onChange,
  placeholder = "Password",
  autoComplete = "current-password",
  required = true,
  minLength,
  name = "password",
  testid = "auth-password",
  toggleTestid = "auth-password-toggle",
}) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testid}
        type={show ? "text" : "password"}
        name={name}
        className="w-full rounded-xl border border-[var(--line)] bg-[var(--surface)] pl-4 pr-12 py-3 text-[var(--ink)] text-base outline-none focus:border-[var(--pine)] focus:ring-2 focus:ring-[var(--pine-soft)] transition-all duration-200 placeholder:text-[var(--ink5)]"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        minLength={minLength}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        data-testid={toggleTestid}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        tabIndex={-1}
        className="absolute right-1 top-1/2 -translate-y-1/2 h-11 w-11 flex items-center justify-center rounded-lg text-[var(--ink4)] hover:text-[var(--pine)] active:text-[var(--pine-dark)] transition-colors duration-150"
      >
        {show ? <EyeOff size={18} strokeWidth={1.8} /> : <Eye size={18} strokeWidth={1.8} />}
      </button>
    </div>
  );
};

export default PasswordField;
